import { Autocomplete, CircularProgress, TextField } from '@mui/material';

export default function AutoComplete({
  placeholder,
  label,
  options,
  groupBy,
  onChange,
  loading,
  width,
  value,
  isOptionEqualToValue,
  helperText,
  getOptionLabel,
  getOptionKey,
  renderOption,
  multiple,
  filterSelectedOptions = true,
  filterOptions,
  freeSolo,
  renderTags,
  disabled = false,
  ...props
}) {
  return (
    <Autocomplete
      key={options}
      value={value}
      options={options}
      groupBy={(option) => option[groupBy]}
      onChange={onChange}
      disabled={disabled}
      filterSelectedOptions={filterSelectedOptions}
      multiple={multiple}
      freeSolo={freeSolo}
      disableCloseOnSelect={multiple}
      noOptionsText='No matches for your search'
      sx={{ width: width }}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionLabel={getOptionLabel}
      getOptionKey={getOptionKey}
      renderOption={renderOption}
      filterOptions={filterOptions}
      renderTags={renderTags}
      aria-label={label}
      renderInput={(params) => (
        <TextField
          {...params}
          variant='outlined'
          sx={{ bgcolor: 'background.paper', ...props.sx }}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          disabled={disabled}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: { ...params.InputLabelProps?.sx, color: 'text.primary' },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color='inherit' size={20} />}{' '}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          {...props}
        />
      )}
    />
  );
}
